import React from "react";
import verified from "../../assets/verified.svg";

const QuestionnaireCompletion = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-80 w-screen h-screen flex justify-center items-center font-inter">
      <div className="bg-white rounded-[10px] px-[75px] flex flex-col justify-center items-center gap-1.5 py-[50px]">
        <img src={verified} alt="" className="" />
        <h1 className="text-[22px] font-semibold mt-1">Success!</h1>
        <p className="font-[550] max-w-[250px] text-center leading-5 pt-1">
          Questionnaire has been successfully completed.
        </p>
        <button
          className="bg-[#55C880] px-5 py-1.5 rounded-[10px] text-white mt-8"
          onClick={onClose}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default QuestionnaireCompletion;
